import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { postObservaciones } from "../../../../redux/actions/resolucion";
import { StyledResolucion } from "../../../styled/Prevencion";
import ObservacionesForm from "./ObservacionesForm";

const initialValues = {
  observacionesGenerales: "Sin Observaciones",
  descripcionActividadEstablecimiento: "",
};

const ObservacionesContainer = ({
  nextForm,
  handleCancelResolucion,
  establecimiento,
}) => {
  const dispatch = useDispatch();

  const observacionesRedux = useSelector(
    (state) => state.resolucion.postResolucion.observaciones
  );

  const [formModel, setFormModel] = useState(null);

  useEffect(() => {
    if (establecimiento != null) {
      setFormModel(() => ({
        ...initialValues,
        observacionesGenerales:
          observacionesRedux?.observacionesGenerales?.trim() ||
          initialValues.observacionesGenerales,
        descripcionActividadEstablecimiento:
          observacionesRedux?.descripcionActividadEstablecimiento?.trim() ||
          establecimiento.actividad?.trim() ||
          initialValues.descripcionActividadEstablecimiento,
      }));
    }
  }, [establecimiento]);

  const handleSubmit = (values) => {
    dispatch(postObservaciones(values));
    nextForm("Sustancias");
  };

  return (
    <StyledResolucion.FormsContainer>
      <ObservacionesForm
        handleSubmit={handleSubmit}
        handleCancelForm={handleCancelResolucion}
        formModel={formModel}
      />
    </StyledResolucion.FormsContainer>
  );
};

export default ObservacionesContainer;
